import { OrderPlanningRowAction, ReasonMap } from "./OrderPlanningRowAction";
import { Button } from "@mcleod/components";
import { PlanningTableRowActionProps } from "@mcleod/general/src/planning/PlanningTableRowAction";
import { getDispatchControlValue } from "@mcleod/general";
import { EquipmentAssignments } from "../../asset/EquipmentAssignments";
import { ModelRow } from "@mcleod/core";

export class RowActionEquipManageAssignments extends OrderPlanningRowAction {
    override getButton(): Button {
        return this.toolPanel.buttonEquipManageAssign;
    }

    override getButtonId(): string {
        return "buttonEquipManageAssign";
    }

    override getFieldsUsedInThisFile(): string[] {
        return ["dispatchby_preassign_count", "tractor", "driver1_id", "movement_id"];
    }

    override actionValidateSelection(selectedRows: ModelRow[], reasonMap: ReasonMap): void {
        // There should only be one row selected
        const hasPreassignCount = selectedRows[0].get("dispatchby_preassign_count") > 0;
        if (!hasPreassignCount) {
            this.addReason(reasonMap, "no_preassignments", "Equipment has no preassignments");
        }
    }

    override execute(props: PlanningTableRowActionProps) {
        const modelRow = props.selectedRows[0]?.data as ModelRow;
        if (modelRow == null)
            return;

        const dispatchBy = getDispatchControlValue("dispatch_by");
        const equipmentId: string = dispatchBy == "T" ? modelRow.get("tractor") : modelRow.get("driver1_id");
        EquipmentAssignments.showSlideout({
            equipmentId: equipmentId,
            tractorId: modelRow.get("tractor"),
            movementId: modelRow.get("movement_id")
        });
    }
}
